import useApiWorker from 'hooks/useApiWorker';
import { Variable, VariableIdentifier } from '../types/variable';

const defaultErrorResponse: ApiResponse<Variable> = {
  success: false,
  message: 'An error occurred',
};

export async function ListVariables(): Promise<ApiListResponse<VariableIdentifier>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<Array<VariableIdentifier>>(`/variables`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function GetVariable(variableName: string): Promise<ApiResponse<Variable>> {
  const apiWorker = useApiWorker();
  return apiWorker
    .get<Variable>(`/variables/${variableName}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return { success: false, message: error.response.data.message };
    });
}

export async function AddVariable(variable: Variable): Promise<ApiResponse<Variable>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .post<Variable>(`/variables`, variable)
    .then(() => {
      return { success: true, variable };
    })
    .catch((error) => {
      return {
        variable,
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function UpdateVariable(variableName: string, variable: Variable): Promise<ApiResponse<Variable>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .put<Variable>(`/variables/${variableName}`, variable)
    .then(() => {
      return { success: true, variable };
    })
    .catch((error) => {
      return {
        variable,
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function DeleteVariable(variable: Variable): Promise<ApiResponse<Variable>> {
  const { Name } = variable;
  const apiWorker = useApiWorker();

  return apiWorker
    .delete(`/variables/${Name}`)
    .then(() => {
      return { success: true, variable };
    })
    .catch((error) => {
      return { success: false, message: error.response.data };
    });
}
